import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const Disclaimer = () => {
  const pathName = useLocation().pathname;
  return (
    <Container maxWidth="md">
      <Box py={4}>
        <Typography variant="h4" gutterBottom>
          Disclaimer
        </Typography>

        <Typography variant="body1" paragraph>
          Blue Bike is an online platform designed to help users buy and sell
          used bikes conveniently and securely. While we strive to maintain the
          accuracy and reliability of the content and services provided, Blue
          Bike makes no guarantees regarding the completeness, accuracy, or
          reliability of any listings, images, or user-generated content
          displayed on the platform.
        </Typography>

        <Typography variant="body1" paragraph>
          By using Blue Bike, you agree to the terms outlined in our{" "}
          <Link
            to="/privacy"
            className={`hover:text-yellow-300 ${
              pathName === "/privacy" && "font-semibold"
            }`}
          >
            Privacy&nbsp;
          </Link>
          , including how we collect, use, and protect your personal
          information. We take reasonable steps to safeguard your data; however,
          we cannot guarantee absolute security for information transmitted over
          the internet.
        </Typography>

        <Typography variant="body1" paragraph>
          Please note:
        </Typography>

        <ul style={{ paddingLeft: "1.5rem" }}>
          <li>
            <Typography variant="body1">
              Blue Bike is not responsible for the actions or representations of
              individual users, sellers, or buyers on the platform.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Users are solely responsible for the accuracy of the data they
              provide in listings or messages.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Communication between buyers and sellers is facilitated for
              convenience, and Blue Bike is not liable for any disputes,
              transactions, or issues arising from such interactions.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Listings are intended for users aged 18 and above. If you are
              under 18, you are not permitted to use our services.
            </Typography>
          </li>
        </ul>

        <Typography variant="body1" paragraph>
          Use of this platform constitutes acceptance of these terms. If you do
          not agree with our practices or policies, we recommend refraining from
          using Blue Bike.
        </Typography>

        <Typography variant="body1" paragraph>
          For questions, concerns, or requests regarding your data, please
          contact us at{" "}
          <Link href="mailto:support@bluebike.in">support@bluebike.in</Link>.
        </Typography>

        <Typography
          variant="caption"
          display="block"
          color="text.secondary"
          mt={2}
        >
          Last updated: April 19, 2025
        </Typography>
      </Box>
    </Container>
  );
};

export default Disclaimer;
